import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./App.css";

import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import RavaqPage from "./pages/RavaqPage";
import ArticleDetailPage from "./pages/ArticleDetailPage";
import PublicationsPage from "./pages/PublicationsPage";
import PublicationDetailPage from "./pages/PublicationDetailPage";
import TopicDetailPage from "./pages/TopicDetailPage";
import IssueDetailPage from "./pages/IssueDetailPage";
import IssueTopicDetailPage from "./pages/IssueTopicDetailPage";
import AdminRoute from "./components/AdminRoute";
import AdminDashboardPage from "./pages/admin/AdminDashboardPage";
import AdminArticlesPage from "./pages/admin/AdminArticlesPage";
import ArticleFormPage from "./pages/admin/ArticleFormPage";
import AdminPublicationsPage from "./pages/admin/AdminPublicationsPage";
import PublicationFormPage from "./pages/admin/PublicationFormPage";
import PublicationTopicsPage from "./pages/admin/PublicationTopicsPage";
import TopicFormPage from "./pages/admin/TopicFormPage";
import AdminIssuesPage from "./pages/admin/AdminIssuesPage";
import IssueFormPage from "./pages/admin/IssueFormPage";
import IssueTopicsPage from "./pages/admin/IssueTopicsPage";
import IssueTopicFormPage from "./pages/admin/IssueTopicFormPage";
import AdminFeaturedPage from "./pages/admin/AdminFeaturedPage";
import AdminPinnedHomePage from "./pages/admin/AdminPinnedHomePage";
import AdminChangePasswordPage from "./pages/admin/AdminChangePasswordPage";
import AdminNewAdminPage from "./pages/admin/AdminNewAdminPage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Section A: public, no auth required. */}
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/ravaq" element={<RavaqPage />} />
        <Route path="/articles/:id" element={<ArticleDetailPage />} />
        <Route path="/publications" element={<PublicationsPage />} />
        <Route path="/publications/:slug" element={<PublicationDetailPage />} />
        <Route path="/publications/:slug/topics/:topicId" element={<TopicDetailPage />} />
        <Route path="/issues/:id" element={<IssueDetailPage />} />
        <Route path="/issues/:id/topics/:topicId" element={<IssueTopicDetailPage />} />

        {/* Section C: admin-only. AdminRoute itself prompts for admin login
            when there's no valid admin session, rather than redirecting to
            a separate page — there's no public account system anymore. */}
        <Route
          path="/admin"
          element={
            <AdminRoute>
              <AdminDashboardPage />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/articles"
          element={
            <AdminRoute>
              <AdminArticlesPage />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/articles/new"
          element={
            <AdminRoute>
              <ArticleFormPage />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/articles/:id/edit"
          element={
            <AdminRoute>
              <ArticleFormPage />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/publications"
          element={
            <AdminRoute>
              <AdminPublicationsPage />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/publications/new"
          element={
            <AdminRoute>
              <PublicationFormPage />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/publications/:slug/edit"
          element={
            <AdminRoute>
              <PublicationFormPage />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/publications/:slug/topics"
          element={
            <AdminRoute>
              <PublicationTopicsPage />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/publications/:slug/topics/new"
          element={
            <AdminRoute>
              <TopicFormPage />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/publications/:slug/topics/:topicId/edit"
          element={
            <AdminRoute>
              <TopicFormPage />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/issues"
          element={
            <AdminRoute>
              <AdminIssuesPage />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/issues/new"
          element={
            <AdminRoute>
              <IssueFormPage />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/issues/:id/edit"
          element={
            <AdminRoute>
              <IssueFormPage />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/issues/:id/topics"
          element={
            <AdminRoute>
              <IssueTopicsPage />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/issues/:id/topics/new"
          element={
            <AdminRoute>
              <IssueTopicFormPage />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/issues/:id/topics/:topicId/edit"
          element={
            <AdminRoute>
              <IssueTopicFormPage />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/featured"
          element={
            <AdminRoute>
              <AdminFeaturedPage />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/pinned-home"
          element={
            <AdminRoute>
              <AdminPinnedHomePage />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/change-password"
          element={
            <AdminRoute>
              <AdminChangePasswordPage />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/admins/new"
          element={
            <AdminRoute>
              <AdminNewAdminPage />
            </AdminRoute>
          }
        />

        {/* Any unmatched URL lands here instead of a blank page. */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
